import { useSearchParams } from "next/navigation";
import { useRouter } from "next/router";

import {
  ImpactChainUtmSourceName,
  OldImpactChainUtmSourceName,
} from "../components/ThankYouPage/ThankYouPageContent/ImpactChainThanksYouPageContent";

export const useFormQueryParams = () => {
  const searchParams = useSearchParams();
  const sessionId = searchParams.get("sessionId");
  const emailDeliveryId = searchParams.get("emailDeliveryId");
  const impactChainUtmSourceEmail =
    searchParams.get(ImpactChainUtmSourceName) || searchParams.get(OldImpactChainUtmSourceName);
  // eslint-disable-next-line @simplyk/zeffy-linter/avoid-router-query
  const { query } = useRouter();

  const { donationFormId, campaignId, ticketingId } = query as {
    donationFormId?: string;
    campaignId?: string;
    ticketingId?: string;
  };

  return {
    sessionId,
    emailDeliveryId,
    donationFormId,
    campaignId,
    ticketingId,
    impactChainUtmSourceEmail,
  };
};
